export interface IDimplOps {
    azureObjectId: string;
    name: string;
}

export const DimplOpsGraphQLFields =
    'azureObjectId name';
